import React from 'react';
import { FaTools, FaRocket, FaBuilding, FaPeopleArrows, FaGlassCheers } from 'react-icons/fa';
import { motion } from 'framer-motion';
import aboutImage from '../style/images/IMP07706.JPG'; // Ensure you have an image for the about section
import WhyCatapult from './WhyCatapult';
import WhatWeDo from './WhatWeDo';

const ServiceCard = ({ icon: Icon, title, description }) => (
  <motion.div
    className="service-item"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5 }}
  >
    <Icon size={40} style={{ marginBottom: '1rem', color: '#cda555' }} />
    <h3>{title}</h3>
    <p>{description}</p>
  </motion.div>
);

const AboutUs = () => {
  return (
    <>
      <section id="about" className="about-section">
        <div className="about-container">
          <div className="about-text">
            <h2 className="section-title">Our Story</h2>
            <h3 className="about-subtitle">We turn moments into timeless memories</h3>
            <div className="about-divider"></div>
            <p>
              <strong>01</strong><br />
              At Catapult Media Work, we believe that every event is a story waiting to be told — an experience designed not just to impress, but to inspire. As a full-service event and brand experience agency, we specialize in creating immersive, strategic, and flawlessly executed events that elevate brands, engage audiences, and leave lasting impressions.
            </p>
            <p>
              With a blend of creative storytelling, marketing strategy, and precision planning, Catapult Media Work transforms concepts into experiences — from intimate brand activations to large-format corporate spectacles. Our team brings together expertise in event management, brand consulting, and media strategy, ensuring that every project reflects both aesthetic excellence and measurable business impact.
            </p>
            <a href="#services" className="discover-button">Discover our services</a>
          </div>

          <div className="about-image">
            {/* Optional image */}
            <img src={aboutImage} alt="Catapult Media About Us" />
          </div>
        </div>
      </section>

      <WhatWeDo />

      <section id="services" className="section">
        <div className="container">
          <h2 className="section-title">Our Services</h2>
          <div className="section-divider"></div>

          <div className="service-blocks">
            <ServiceCard icon={FaTools} title="Event Stall Fabricators" description="We design and fabricate visually captivating event stalls that reflect your brand identity." />
            <ServiceCard icon={FaRocket} title="Product Launch" description="We orchestrate spectacular product launches that create buzz, capture attention, and leave a lasting impression." />
            <ServiceCard icon={FaBuilding} title="Corporate Events" description="Professional, polished corporate events tailored to reflect your company’s values and goals." />
            <ServiceCard icon={FaPeopleArrows} title="MICE" description="We organize Meetings, Incentives, Conferences, and Exhibitions that help you grow and engage globally." />
            <ServiceCard icon={FaGlassCheers} title="Social Events" description="Celebrate special moments in style with our full-service planning for weddings and milestone events." />
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;
